import { render } from "./BubbleTwo.vue?vue&type=template&id=56889848"
import script from "./BubbleTwo.vue?vue&type=script&lang=js"
export * from "./BubbleTwo.vue?vue&type=script&lang=js"

import "./BubbleTwo.vue?vue&type=style&index=0&id=56889848&lang=css"
script.render = render

export default script